import React, { FC, useEffect, useState } from 'react'
import { LoadingView, RootWelcomePageTemplate } from '../components'
import {
    GetRPOrganizationsResponse,
    RPOrganizationOverview,
    User,
} from '@hazadapt-git/public-core-base'

interface RootWelcomePageProps {
    loading: boolean
    orgResponse: GetRPOrganizationsResponse | undefined
    publicUser: User | undefined
}

export const RootWelcomePage: FC<RootWelcomePageProps> = ({
    loading,
    orgResponse,
    publicUser,
}) => {
    const [userOrgs, setUserOrgs] = useState<
        RPOrganizationOverview[] | undefined
    >()

    useEffect(() => {
        document.title = 'ResiliencePoint'
    }, [])

    useEffect(() => {
        if (!orgResponse) {
            setUserOrgs(undefined)
            return
        }
        const yours = orgResponse.yours ?? []
        setUserOrgs(
            orgResponse.organizations.filter((org) => yours.includes(org.id)),
        )
    }, [orgResponse])

    return loading ? (
        <LoadingView />
    ) : (
        <RootWelcomePageTemplate
            userOrgs={userOrgs}
            publicUser={publicUser}
        />
    )
}
